import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule } from "@angular/core";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxMaskModule, IConfig } from "ngx-mask";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { TagInputModule } from "ngx-chips";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { HttpClientJsonpModule, HttpClientModule } from "@angular/common/http";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import localePtBr from "@angular/common/locales/pt";
import { registerLocaleData } from "@angular/common";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { LoaderComponent } from "./loader/loader.component";
import { HeaderComponent } from "./header/header.component";
import { LoginComponent } from "./login/login.component";
import { ServiceWorkerModule } from "@angular/service-worker";
import { environment } from "../environments/environment";
import { ReportsComponent } from "./reports/reports.component";
import { ReportsRoutingModule } from "./reports/reports-routing.module";
import { SalesReportComponent } from "./reports/sales-report/sales-report.component";
import { DatepickerRangeComponent } from "./components/datepicker-range/datepicker-range.component";
import { TypeaheadComponent } from "./components/typeahead/typeahead.component";
import { TeamsComponent } from "./teams/teams.component";
import { TeamsDetailsComponent } from "./teams/teams-details/teams-details.component";
import { TeamsRoutingModule } from "./teams/teams-routing.module";
import { TeamsAddComponent } from "./teams/teams-add/teams-add.component";
import { TeamsEditComponent } from "./teams/teams-edit/teams-edit.component";
import { TeamsDeleteComponent } from "./teams/teams-delete/teams-delete.component";
import { SettingsComponent } from "./settings/settings.component";
import { SettingsRoutingModule } from "./settings/settings-routing.module";
import { EnterpriseComponent } from "./settings/enterprise/enterprise.component";
import { ParamsVendasComponent } from "./settings/params-vendas/params-vendas.component";
import { MotNaoCompraComponent } from "./settings/mot-nao-compra/mot-nao-compra.component";
import { PlanosComponent } from "./settings/planos/planos.component";
import { PlanoDetailsComponent } from "./settings/planos/plano-details/plano-details.component";
import { UsersComponent } from "./users/users.component";
import { UsersAddComponent } from "./users/users-add/users-add.component";
import { UsersRoutingModule } from "./users/users-routing.module";
import { UsersDetailsComponent } from "./users/users-details/users-details.component";
import { UsersEditComponent } from "./users/users-edit/users-edit.component";
import { NotpermitedComponent } from "./notpermited/notpermited.component";
import { SalesComponent } from "./sales-module/sales/sales.component";
import { SynchronizedSalesComponent } from "./sales-module/sales/synchronized-sales/synchronized-sales.component";
import { ApprovedSalesComponent } from "./sales-module/sales/approved-sales/approved-sales.component";
import { WaitApprovalsSalesComponent } from "./sales-module/sales/wait-approvals-sales/wait-approvals-sales.component";
import { ErrorsSalesComponent } from "./sales-module/sales/errors-sales/errors-sales.component";
import { ReturnedSalesComponent } from "./sales-module/sales/returned-sales/returned-sales.component";
import { SalesDetailsComponent } from "./sales-module/sales/sales-details/sales-details.component";
import { SalesRoutingModule } from "./sales-module/sales/sales-routing.module";
import { DashCobrancasComponent } from "./dashboard/dash-cobrancas/dash-cobrancas.component";
import { DashSalesComponent } from "./dashboard/dash-sales/dash-sales.component";
import { SalesModuleComponent } from "./sales-module/sales-module.component";
import { SalesModuleRoutingModule } from "./sales-module/sales-module-routing.module";
import { LeadsComponent } from "./sales-module/leads/leads.component";
import { LeadsDetailsComponent } from "./sales-module/leads/leads-details/leads-details.component";
import { SaleSummaryComponent } from "./sales-module/sales/components/sale-summary/sale-summary.component";
import { QRCodeModule } from "angularx-qrcode";
import { ChargesComponent } from "./charges-module/charges/charges.component";
import { ChargesDistributionComponent } from "./charges-module/charges-distribution/charges-distribution.component";
import { ChargesRoutingModule } from "./charges-module/charges/charges-routing.module";
import { WaitApprovalsChargesComponent } from "./charges-module/charges/wait-approvals-charges/wait-approvals-charges.component";
import { ApprovedChargesComponent } from "./charges-module/charges/approved-charges/approved-charges.component";
import { SynchronizedChargesComponent } from "./charges-module/charges/synchronized-charges/synchronized-charges.component";
import { RescheduledChargesComponent } from "./charges-module/charges/rescheduled-charges/rescheduled-charges.component";
import { ErrorsChargesComponent } from "./charges-module/charges/errors-charges/errors-charges.component";
import { RecurrencesChargesComponent } from "./charges-module/charges/recurrences-charges/recurrences-charges.component";
import { RejectedChargesComponent } from "./charges-module/charges/rejected-charges/rejected-charges.component";
import { ChargesDetailsComponent } from "./charges-module/charges/charges-details/charges-details.component";
import { ChargesModuleComponent } from "./charges-module/charges-module.component";
import { ChargesModuleRoutingModule } from "./charges-module/charges-module-routing.module";
import { WaitingCustomerSalesComponent } from "./sales-module/sales/waiting-customer-sales/waiting-customer-sales.component";
import { OnoffcycleChargesComponent } from "./charges-module/charges/onoffcycle-charges/onoffcycle-charges.component";
import { ReasonReturnComponent } from "./charges-module/charges/reason-return/reason-return.component";
import { NotifiedChargesComponent } from "./charges-module/charges/notified-charges/notified-charges.component";
import { RecebimentosReportComponent } from "./charges-module/charges/components/recebimentos-report/recebimentos-report.component";
import { EstornadosChargesComponent } from "./charges-module/charges/estornados-charges/estornados-charges.component";

registerLocaleData(localePtBr);

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [
    AppComponent,
    SidebarComponent,
    HeaderComponent,
    DashboardComponent,
    LoaderComponent,
    LoginComponent,
    ReportsComponent,
    SalesReportComponent,
    DatepickerRangeComponent,
    TypeaheadComponent,
    TeamsComponent,
    TeamsDetailsComponent,
    TeamsAddComponent,
    TeamsEditComponent,
    TeamsDeleteComponent,
    SettingsComponent,
    EnterpriseComponent,
    ParamsVendasComponent,
    MotNaoCompraComponent,
    PlanosComponent,
    PlanoDetailsComponent,
    UsersComponent,
    UsersAddComponent,
    UsersDetailsComponent,
    UsersEditComponent,
    NotpermitedComponent,
    SalesComponent,
    SynchronizedSalesComponent,
    ApprovedSalesComponent,
    WaitApprovalsSalesComponent,
    ErrorsSalesComponent,
    ReturnedSalesComponent,
    SalesDetailsComponent,
    DashCobrancasComponent,
    DashSalesComponent,
    LeadsComponent,
    SalesModuleComponent,
    LeadsDetailsComponent,
    SaleSummaryComponent,
    ChargesComponent,
    ChargesDistributionComponent,
    WaitApprovalsChargesComponent,
    ApprovedChargesComponent,
    SynchronizedChargesComponent,
    RescheduledChargesComponent,
    ErrorsChargesComponent,
    RecurrencesChargesComponent,
    RejectedChargesComponent,
    ChargesDetailsComponent,
    ChargesModuleComponent,
    WaitingCustomerSalesComponent,
    OnoffcycleChargesComponent,
    ReasonReturnComponent,
    NotifiedChargesComponent,
    RecebimentosReportComponent,
    EstornadosChargesComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    HttpClientJsonpModule,
    ChargesRoutingModule,
    ChargesModuleRoutingModule,
    SalesRoutingModule,
    SalesModuleRoutingModule,
    ReportsRoutingModule,
    TeamsRoutingModule,
    SettingsRoutingModule,
    UsersRoutingModule,
    AppRoutingModule,
    NgbModule,
    QRCodeModule,
    TagInputModule,
    NgMultiSelectDropDownModule.forRoot(),
    NgxMaskModule.forRoot(maskConfig),
    ServiceWorkerModule.register("ngsw-worker.js", {
      enabled: environment.production,
    }),
  ],
  providers: [SidebarComponent],
  bootstrap: [AppComponent],
})
export class AppModule {}
